import * as React from 'react'
import * as styles from './Footer.module.css'
import Logo from '../../images/logo.png'

export default function Footer() {
    return (
        <footer className={`${styles.footer} ${styles.alignFull}`}>
            <div className={styles.footerContainer}>
                <img src={Logo} alt="CryptoMerchants" className={styles.image} />
            </div>
        </footer>
    )
}
